import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';

const TicketsContent = lazy(() => import('../../components/Pages/Tickets'));

export default function Tickets(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Tickets page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <TicketsContent />
      </Suspense>
    </Layout>
  );
}
